import { useMutation } from 'react-query';
import axios from 'axios';

import { AwsConfigApiGateway } from '@/utils/config/api';

interface ResendVerificationEmailRequest {
  email: string;
}

interface ResendVerificationEmailResponse {
  message: string;
}

export function useResendVerificationEmail() {
  return useMutation<ResendVerificationEmailResponse, Error, ResendVerificationEmailRequest>(async (data) => {
    const response = await axios.post<ResendVerificationEmailResponse>(
      `${AwsConfigApiGateway.pooledTenantApiUrl}/auth/resend-verification-email`,
      data,
      {
        headers: {
          'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
          'Content-Type': 'application/json',
        },
      },
    );
    return response.data;
  });
}
